import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { get } from "../../../../../lib/api";
import Loader from "../../../../../components/Loader";
import { Box, Text } from "../../../../../designSystem";
import Target from "../../../../../components/Images/Target";
import { redirectToShowLinkHandler } from "../../../../../lib/utils";

const AudiobookListContainer = styled.div`
    display: flex;
    padding: 16px;
    background-color: white;
`

const LiveBox = styled.p`
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
    margin-top: 12px;
    color: rgba(41, 94, 72, 1);
    padding: 8px 16px;
    border-radius: 4px;
    background-color: rgba(84, 181, 133, 0.16);
    width: max-content;
    cursor: pointer;
`

const ShowTitle = styled.p`
    width: 80%;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
const BookImg = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 4px;
`


const AudiobookList = ({ bookId }) => {
    const [list, setList] = useState([])
    const [isLoading, setLoading] = useState(false)
    const [msg,setMsg] = useState('')
    useEffect(() => {
        setLoading(true)
        get(`/content_api/ugc/audio/get_novel_audio_series_mapping/?book_id=${bookId}&view=writer&is_novel=1`).then((res) =>
        {
            setLoading(false)
            setList(res?.result)
            setMsg(res?.message)
        }).catch(() => setLoading(false))
    },[])
    return(
        <AudiobookListContainer>
            {!isLoading && (
                list?.length ? <Box display="flex" gap={16} flexDirection="column">
                {list?.map((series) => (
                    <Box variant="flexCard" justifyContent="unset" alignItems="flex-start" mb={16}>
                        <Box>
                            <BookImg src={series?.image_url} />
                        </Box>
                        <Box ml={16} width="100%">
                            <ShowTitle>{series?.show_title}</ShowTitle>
                            <Text variant="smallText" fontWeight="600" mt={4}>Author: {series?.author_name}<br />
                            Narrator: {series?.narrator_name}</Text>
                            <LiveBox onClick={() => redirectToShowLinkHandler(series?.show_id)}>Your Audio Series Is Live</LiveBox>
                        </Box>
                    </Box>
                ))}
                </Box> : 
                <Box variant="flexCard" justifyContent="center" alignItems="center">
                    <Box>
                        <Target />
                    </Box>
                    <Box ml={16}>
                        <Text variant="caption">{msg}</Text>
                    </Box>
                </Box>
            )}
            {isLoading && <Loader />}
        </AudiobookListContainer>
    )
}

export default AudiobookList